import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=79b9ff1d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=79b9ff1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9ff1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b9ff1d')) {
      api.createRecord('79b9ff1d', component.options)
    } else {
      api.reload('79b9ff1d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=79b9ff1d&scoped=true&", function () {
      api.rerender('79b9ff1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OhOW12vVVT0e/JS/comp/PopupBox.vue"
export default component.exports